module.exports = __webpack_public_path__ + "img/lg_ring_y_l_0_0@2x.c267217c.png";